import { get, isEmpty } from 'lodash';
import { connect } from 'react-redux';

import ReturnsInsuranceUpsell from 'components/ReturnsInsuranceUpsell';
import { CAMPAIGN_NAMES } from 'constants/personalizations';
import * as actions from 'state/actions';
import { ADD_TO_CART_ANALYTICS_ORIGINS } from 'state/constants';
import CartSelector from 'state/selectors/cart';
import PersonalizationsSelector from 'state/selectors/personalizations';

const mapStateToProps = state => {
  const { itemIds } = CartSelector.getCart(state);
  const cartLineItems = CartSelector.getCartLineItems(state);
  const allItemsAreFinalSale =
    cartLineItems.length > 0 && cartLineItems.every(item => item.isFinalSale);

  const returnsInsuranceCampaignData = PersonalizationsSelector.getCampaignVariationData(
    state,
    CAMPAIGN_NAMES.RETURNS_INSURANCE_UPSELL
  );

  const returnsInsuranceCampaignVariant = returnsInsuranceCampaignData?.payload?.data?.variant;
  const productImageUrl = returnsInsuranceCampaignData?.payload?.data?.productImageUrl;
  const analyticsData = returnsInsuranceCampaignData?.analyticsMetadata;
  const isReturnsInsuranceCampaignLoading = PersonalizationsSelector.getIsExperimentLoading(
    state,
    CAMPAIGN_NAMES.RETURNS_INSURANCE_UPSELL
  );

  // Check if any items in the cart are being updated, added, or removed
  const itemsBeingUpdated = get(state, ['ajaxCart', 'itemsBeingUpdated'], {});
  const itemsBeingAdded = get(state, ['ajaxCart', 'itemsBeingAdded'], {});
  const itemsBeingRemoved = get(state, ['ajaxCart', 'itemsBeingRemoved'], {});

  // Consider the insurance buttons disabled if any cart operation is in progress
  const isBeingUpdated = !isEmpty(itemsBeingUpdated) || !isEmpty(itemsBeingAdded);
  const isBeingRemoved = !isEmpty(itemsBeingRemoved);

  return {
    allItemsAreFinalSale,
    returnsInsuranceCampaignVariant,
    isBeingUpdated,
    isBeingRemoved,
    itemIds,
    isReturnsInsuranceCampaignLoading,
    productImageUrl,
    analyticsData,
  };
};

const mapDispatchToProps = dispatch => ({
  addReturnsInsurance: variantId => {
    return dispatch(
      actions.addLineItems({ [variantId]: 1 }, { origination: ADD_TO_CART_ANALYTICS_ORIGINS.CART })
    );
  },
  removeReturnsInsurance: variantId => {
    return dispatch(actions.removeLineItem(variantId));
  },
  handleReturnsInsuranceExposure: (isExposed, analyticsData) => {
    return dispatch(actions.handleReturnsInsuranceExposure(isExposed, analyticsData));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ReturnsInsuranceUpsell);
